// extracted by mini-css-extract-plugin
module.exports = {"list":"_3SlHW_","item":"_2JQVsn","link":"_3dO8UA"};